(() => {
  if (window.LAFORTE_EXPERIENCE_READY) return;
  window.LAFORTE_EXPERIENCE_READY = true;

  const rootPath = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const isHindi = (document.documentElement.lang || '').toLowerCase().indexOf('hi') === 0;
  const ui = isHindi ? {
    updating:'अपडेट हो रहा है…', chooseOption:'कृपया पहले एक विकल्प चुनें।', adding:'जोड़ा जा रहा है…',
    addingCart:'कार्ट में जोड़ा जा रहा है…', addedCart:'कार्ट में जुड़ गया।', addedButton:'जुड़ गया ✓',
    tryAgain:'फिर कोशिश करें', addToCart:'कार्ट में जोड़ें', networkIssue:'नेटवर्क समस्या—फिर कोशिश करें',
    cartUpdateError:'कार्ट अपडेट नहीं हो सका', finder:'त्वरित उत्पाद खोज', searchPlaceholder:'उत्पाद, कलेक्शन या सहायता खोजें…',
    closeSearch:'त्वरित खोज बंद करें', untitled:'बिना शीर्षक', popular:'लोकप्रिय रास्ते', newArrivals:'नए उत्पाद',
    kitchenAppliances:'रसोई उपकरण', kitchenTools:'रसोई के उपकरण', copperDrinkware:'कॉपर ड्रिंकवेयर',
    explore:'देखें', searching:'स्टोर में खोजा जा रहा है…', product:'उत्पाद', collection:'कलेक्शन', guide:'गाइड',
    noMatch:'सटीक परिणाम नहीं मिला। “ब्लेंडर” या “कॉपर” जैसा आसान शब्द आज़माएँ।',
    searchError:'खोज अभी उपलब्ध नहीं है। कृपया फिर कोशिश करें।', secureCheckout:'सुरक्षित चेकआउट',
    protectedPayment:'सुरक्षित भुगतान अनुभव', checkoutHelp:'चेकआउट में मदद चाहिए?', whatsappSupport:'WhatsApp सहायता',
    quantity:'मात्रा', decrease:'मात्रा घटाएँ', increase:'मात्रा बढ़ाएँ', removeItem:'आइटम हटाएँ', productImage:' उत्पाद चित्र'
  } : {
    updating:'Updating…', chooseOption:'Please choose an option first.', adding:'Adding…',
    addingCart:'Adding to your cart…', addedCart:'Added to cart — nice pick.', addedButton:'Added ✓',
    tryAgain:'Try again', addToCart:'Add to cart', networkIssue:'Network issue — please try again',
    cartUpdateError:'Could not update cart', finder:'Quick product finder', searchPlaceholder:'Search products, collections or help…',
    closeSearch:'Close quick search', untitled:'Untitled', popular:'Popular paths', newArrivals:'New arrivals',
    kitchenAppliances:'Kitchen appliances', kitchenTools:'Kitchen tools', copperDrinkware:'Copper drinkware',
    explore:'Explore', searching:'Searching the store…', product:'Product', collection:'Collection', guide:'Guide',
    noMatch:'No exact match. Try a simpler word like “blender” or “copper”.',
    searchError:'Search took a coffee break. Please try again.', secureCheckout:'Secure checkout',
    protectedPayment:'Protected payment experience', checkoutHelp:'Need checkout help?', whatsappSupport:'WhatsApp support',
    quantity:'Quantity', decrease:'Decrease quantity', increase:'Increase quantity', removeItem:'Remove item', productImage:' product image'
  };
  let toastTimer;
  const showToast = (message, isError) => {
    let toast = document.querySelector('.lf-cart-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'lf-cart-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      toast.innerHTML = '<span class="lf-cart-toast__icon" aria-hidden="true">✓</span><span class="lf-cart-toast__text"></span>';
      document.body.appendChild(toast);
    }
    toast.classList.toggle('is-error', !!isError);
    toast.querySelector('.lf-cart-toast__icon').textContent = isError ? '!' : '✓';
    toast.querySelector('.lf-cart-toast__text').textContent = message;
    toast.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.classList.remove('is-visible'), isError ? 4200 : 2400);
  };

  let cartRefreshController;
  const cartTotalTargets = '[data-cart-tt-price], [data-er-cart-total-price]';

  const formatCartMoney = (cents, currency) => {
    const amount = Number(cents || 0) / 100;
    const code = currency || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'INR';
    try {
      if (code === 'INR') {
        return 'Rs. ' + new Intl.NumberFormat('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(amount);
      }
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: code, minimumFractionDigits: 2, maximumFractionDigits: 2
      }).format(amount);
    } catch (_) {
      return code + ' ' + amount.toFixed(2);
    }
  };

  const setCartUpdating = (busy) => {
    document.querySelectorAll(cartTotalTargets).forEach(el => {
      if (busy) {
        if (!el.dataset.lfPreviousTotal) el.dataset.lfPreviousTotal = el.textContent || '';
        el.textContent = ui.updating;
        el.classList.add('lf-cart-total-updating');
        el.setAttribute('aria-busy', 'true');
      } else {
        el.classList.remove('lf-cart-total-updating');
        el.removeAttribute('aria-busy');
      }
    });
  };

  const restoreCartTotals = () => {
    document.querySelectorAll(cartTotalTargets).forEach(el => {
      if (el.dataset.lfPreviousTotal) el.textContent = el.dataset.lfPreviousTotal;
      delete el.dataset.lfPreviousTotal;
      el.classList.remove('lf-cart-total-updating');
      el.removeAttribute('aria-busy');
    });
  };

  const refreshMiniCart = async (expectedCount) => {
    if (cartRefreshController) cartRefreshController.abort();
    cartRefreshController = new AbortController();
    const response = await fetch(rootPath + '?section_id=mini_cart', {
      signal: cartRefreshController.signal,
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    });
    if (!response.ok) throw new Error('Cart drawer refresh failed');
    const html = await response.text();
    const nextDocument = new DOMParser().parseFromString(html, 'text/html');
    const currentDrawer = document.querySelector('#t4s-mini_cart');
    const nextDrawer = nextDocument.querySelector('#t4s-mini_cart');
    if (!currentDrawer || !nextDrawer) return;

    ['[data-cart-items]', '[data-cart-prices]', '[data-cart-discounts]', '[data-cart-calc-shipping]'].forEach(selector => {
      const current = currentDrawer.querySelector(selector);
      const next = nextDrawer.querySelector(selector);
      if (current && next) {
        current.innerHTML = next.innerHTML;
        current.className = next.className;
      }
    });
    currentDrawer.dataset.ccount = String(Number.isFinite(Number(expectedCount)) ? Number(expectedCount) : (nextDrawer.dataset.ccount || 0));
    document.dispatchEvent(new CustomEvent('lf:cart-drawer-refreshed'));
  };

  const notifyCart = (cart) => {
    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = cart.item_count;
      el.classList.toggle('t4s-op-0', cart.item_count === 0);
    });
    const totalText = formatCartMoney(cart.total_price, cart.currency);
    document.querySelectorAll(cartTotalTargets).forEach(el => {
      el.textContent = totalText;
      delete el.dataset.lfPreviousTotal;
      el.classList.remove('lf-cart-total-updating');
      el.removeAttribute('aria-busy');
    });
    document.dispatchEvent(new CustomEvent('lf:cart-updated', { detail: { cart: cart } }));
    refreshMiniCart(cart.item_count).catch(error => {
      if (error.name !== 'AbortError') console.warn('LA FORTE cart drawer refresh:', error);
    });
  };

  const requestJSON = (url, method, body) => new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open(method || 'GET', url, true);
    xhr.setRequestHeader('Accept', 'application/json');
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    xhr.onload = () => {
      let data = {};
      try { data = JSON.parse(xhr.responseText || '{}'); } catch (_) {}
      if (xhr.status >= 200 && xhr.status < 300) resolve(data);
      else reject(new Error(data.description || data.message || ui.cartUpdateError));
    };
    xhr.onerror = () => reject(new Error(ui.networkIssue));
    xhr.send(body || null);
  });

  const fastAdd = async (form, button) => {
    if (!form || form.dataset.lfCartBusy === 'true') return;
    if (!form.checkValidity()) {
      if (form.reportValidity) form.reportValidity();
      return;
    }

    const variantField = form.querySelector('select[name="id"]') ||
      form.querySelector('input[name="id"]:checked') ||
      Array.from(form.querySelectorAll('input[name="id"]')).find(el => el.value);
    if (!variantField || !variantField.value) {
      showToast(ui.chooseOption, true);
      return;
    }

    form.dataset.lfCartBusy = 'true';
    const originalLabel = button ? button.textContent.trim() : '';
    if (button) {
      button.disabled = true;
      button.classList.add('lf-atc-busy');
      button.textContent = ui.adding;
    }
    const qtyField = form.querySelector('[name="quantity"]');
    const quantity = Math.max(1, Number(qtyField && qtyField.value ? qtyField.value : 1) || 1);
    const firstCount = document.querySelector('[data-cart-count]');
    const previousCount = Number(firstCount && firstCount.textContent ? firstCount.textContent.trim() : 0) || 0;
    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = previousCount + quantity;
      el.classList.remove('t4s-op-0');
    });
    setCartUpdating(true);
    showToast(ui.addingCart, false);

    try {
      const data = new FormData(form);
      data.delete('id');
      data.append('id', variantField.value);
      data.set('quantity', String(quantity));

      await requestJSON(rootPath + 'cart/add.js', 'POST', data);
      const cart = await requestJSON(rootPath + 'cart.js', 'GET');
      notifyCart(cart);
      showToast(ui.addedCart, false);
      if (button) button.textContent = ui.addedButton;

    } catch (error) {
      restoreCartTotals();
      document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = previousCount; });
      console.error('LA FORTE fast cart:', error);
      showToast(error.message || ui.cartUpdateError, true);
      if (button) button.textContent = ui.tryAgain;
    } finally {
      form.dataset.lfCartBusy = 'false';
      setTimeout(() => {
        if (button) {
          button.disabled = false;
          button.classList.remove('lf-atc-busy');
          button.textContent = originalLabel || ui.addToCart;
        }
      }, 1400);
    }
  };

  window.addEventListener('click', (event) => {
    const button = event.target.closest && event.target.closest('form[data-type="add-to-cart-form"] [name="add"]');
    if (!button) return;
    const form = button.closest('form[data-type="add-to-cart-form"]');
    if (!form) return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    if (form.dataset.lfCartBusy === 'true') return;
    fastAdd(form, button);
  }, true);

  window.addEventListener('submit', (event) => {
    const form = event.target.closest && event.target.closest('form[data-type="add-to-cart-form"]');
    if (!form) return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    if (form.dataset.lfCartBusy === 'true') return;
    fastAdd(form, event.submitter || form.querySelector('[name="add"]'));
  }, true);

  const overlay = document.createElement('div');
  overlay.className = 'lf-command-overlay';
  overlay.setAttribute('aria-hidden', 'true');
  overlay.innerHTML = '<div class="lf-command-panel" role="dialog" aria-modal="true" aria-label="' + ui.finder + '">' +
    '<div class="lf-command-head"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="11" cy="11" r="7"></circle><path d="m20 20-3.5-3.5"></path></svg>' +
    '<input class="lf-command-input" type="search" autocomplete="off" placeholder="' + ui.searchPlaceholder + '">' +
    '<button type="button" class="lf-command-close" aria-label="' + ui.closeSearch + '">×</button></div>' +
    '<div class="lf-command-results" aria-live="polite"></div></div>';
  document.body.appendChild(overlay);
  const input = overlay.querySelector('.lf-command-input');
  const results = overlay.querySelector('.lf-command-results');
  let searchTimer;
  let searchController;

  const addResult = (item, type) => {
    const link = document.createElement('a');
    link.className = 'lf-command-result';
    link.href = item.url || '#';
    if (item.image && item.image.url) {
      const img = document.createElement('img');
      img.src = item.image.url;
      img.alt = '';
      img.loading = 'lazy';
      link.appendChild(img);
    } else {
      const placeholder = document.createElement('span');
      placeholder.className = 'lf-command-placeholder';
      link.appendChild(placeholder);
    }
    const copy = document.createElement('span');
    const title = document.createElement('strong');
    title.textContent = item.title || ui.untitled;
    copy.appendChild(title);
    link.appendChild(copy);
    const label = document.createElement('small');
    label.textContent = type;
    link.appendChild(label);
    results.appendChild(link);
  };

  const showShortcuts = () => {
    results.innerHTML = '<div class="lf-command-label">' + ui.popular + '</div>';
    [
      {title:ui.newArrivals,url:rootPath + 'collections/new-arrivals'},
      {title:ui.kitchenAppliances,url:rootPath + 'collections/kitchen-appliances'},
      {title:ui.kitchenTools,url:rootPath + 'collections/kitchen-tools'},
      {title:ui.copperDrinkware,url:rootPath + 'pages/why_copper'}
    ].forEach(item => addResult(item, ui.explore));
  };

  const openSearch = () => {
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    showShortcuts();
    setTimeout(() => input.focus(), 40);
  };
  const closeSearch = () => {
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    input.value = '';
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-lf-open-search]');
    const searchLink = event.target.closest('header a[href="/search"],header a[href="/search/"]');
    if (trigger || searchLink) {
      event.preventDefault();
      openSearch();
    }
  });
  overlay.querySelector('.lf-command-close').addEventListener('click', closeSearch);
  overlay.addEventListener('click', event => { if (event.target === overlay) closeSearch(); });
  document.addEventListener('keydown', event => {
    if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === 'k') {
      event.preventDefault();
      overlay.classList.contains('is-open') ? closeSearch() : openSearch();
    } else if (event.key === 'Escape' && overlay.classList.contains('is-open')) {
      closeSearch();
    }
  });

  input.addEventListener('input', () => {
    clearTimeout(searchTimer);
    const query = input.value.trim();
    if (query.length < 2) { showShortcuts(); return; }
    searchTimer = setTimeout(async () => {
      if (searchController) searchController.abort();
      searchController = new AbortController();
      results.innerHTML = '<div class="lf-command-empty">' + ui.searching + '</div>';
      try {
        const url = rootPath + 'search/suggest.json?q=' + encodeURIComponent(query) +
          '&resources[type]=product,collection,page&resources[limit]=7';
        const response = await fetch(url, { signal: searchController.signal, headers:{'Accept':'application/json'} });
        const data = await response.json();
        const found = data.resources && data.resources.results ? data.resources.results : {};
        results.innerHTML = '';
        let count = 0;
        [['products',ui.product],['collections',ui.collection],['pages',ui.guide]].forEach(group => {
          const uniqueResults = new Map();
          (found[group[0]] || []).forEach(item => {
            const key = (group[1] + ':' + String(item.title || '')).toLowerCase().replace(/[^a-z0-9]+/g, '-');
            const current = uniqueResults.get(key);
            if (!current || String(item.url || '').length < String(current.url || '').length) uniqueResults.set(key, item);
          });
          uniqueResults.forEach(item => {
            addResult(item, group[1]);
            count++;
          });
        });
        if (!count) results.innerHTML = '<div class="lf-command-empty">' + ui.noMatch + '</div>';
      } catch (error) {
        if (error.name !== 'AbortError') results.innerHTML = '<div class="lf-command-empty">' + ui.searchError + '</div>';
      }
    }, 220);
  });

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => entries.forEach(entry => {
      if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }
    }), { threshold: .12 });
    document.querySelectorAll('.lf-goal-card,.lf-copper-page>section').forEach(el => {
      el.classList.add('lf-reveal');
      observer.observe(el);
    });
  }

  const ensureCheckoutAssist = () => {
    const drawer = document.querySelector('#t4s-mini_cart');
    if (!drawer || drawer.querySelector('.lf5-checkout-assist')) return;
    const anchor = drawer.querySelector('[data-cart-prices]') || drawer.querySelector('.t4s-drawer__bottom');
    if (!anchor) return;
    const assist = document.createElement('div');
    assist.className = 'lf5-checkout-assist';
    assist.innerHTML =
      '<div class="lf5-checkout-assist__line"><span aria-hidden="true">✓</span><strong>' + ui.secureCheckout + '</strong><small>' + ui.protectedPayment + '</small></div>' +
      '<div class="lf5-checkout-assist__line"><span aria-hidden="true">↗</span><strong>' + ui.checkoutHelp + '</strong><a href="https://wa.me/919643335959?text=Hi%20LA%27%20FORTE%2C%20I%20need%20help%20completing%20my%20order." target="_blank" rel="noopener">' + ui.whatsappSupport + '</a></div>';
    anchor.insertAdjacentElement('afterend', assist);
  };
  document.addEventListener('DOMContentLoaded', ensureCheckoutAssist);
  document.addEventListener('lf:cart-drawer-refreshed', ensureCheckoutAssist);
  document.addEventListener('click', event => {
    if (event.target.closest('a[href="/cart"],[data-drawer-trigger*="cart"],[data-open-drawer*="cart"]')) setTimeout(ensureCheckoutAssist, 120);
  });
  setTimeout(ensureCheckoutAssist, 600);

  const patchQuantityAccessibility = (scope) => {
    const root = scope && scope.querySelectorAll ? scope : document;
    root.querySelectorAll('input[type="number"][name="quantity"], input[type="number"][name="updates[]"]').forEach(input => {
      if (!input.getAttribute('aria-label')) input.setAttribute('aria-label', ui.quantity);
    });
    root.querySelectorAll('[data-decrease-qty], .t4s-quantity-selector.is--minus').forEach(button => {
      if (!button.getAttribute('aria-label')) button.setAttribute('aria-label', ui.decrease);
    });
    root.querySelectorAll('[data-increase-qty], .t4s-quantity-selector.is--plus').forEach(button => {
      if (!button.getAttribute('aria-label')) button.setAttribute('aria-label', ui.increase);
    });
    root.querySelectorAll('#t4s-mini_cart [data-cart-item] img[alt=""]').forEach(image => {
      const item = image.closest('[data-cart-item]');
      const title = item && item.querySelector('.t4s-mini_cart__title');
      image.alt = title && title.textContent.trim() ? title.textContent.trim() + ui.productImage : ui.productImage.trim();
    });
    root.querySelectorAll('#t4s-mini_cart [data-cart-remove]').forEach(link => {
      if (!link.getAttribute('aria-label')) link.setAttribute('aria-label', ui.removeItem);
    });
    const productHeading = document.querySelector('.t4s-product__title');
    const productTitle = productHeading && productHeading.textContent.trim();
    if (productTitle) {
      root.querySelectorAll('.t4s-product__media-wrapper img[alt=""]').forEach((image, index) => {
        image.alt = productTitle + ui.productImage + ' ' + (index + 1);
      });
    }
    root.querySelectorAll('img.snap-widget-buyonemi:not([alt]), img.snap-widget-buyonemi[alt=""], img.snap_widget_logo_merchant:not([alt]), img.snap_widget_logo_merchant[alt=""]').forEach(image => {
      image.alt = 'Snapmint EMI';
    });
    root.querySelectorAll('img.snap_upi_widget_imgd:not([alt]), img.snap_upi_widget_imgd[alt=""]').forEach(image => {
      image.alt = 'UPI payment';
    });
    root.querySelectorAll('img[src*="Payment_Gateway"]:not([alt]), img[src*="Payment_Gateway"][alt=""], img[data-src*="Payment_Gateway"]:not([alt]), img[data-src*="Payment_Gateway"][alt=""], img[srcset*="Payment_Gateway"]:not([alt]), img[srcset*="Payment_Gateway"][alt=""], img[data-srcset*="Payment_Gateway"]:not([alt]), img[data-srcset*="Payment_Gateway"][alt=""]').forEach(image => {
      image.alt = isHindi ? 'स्वीकृत भुगतान विधियाँ' : 'Accepted payment methods';
    });
  };
  patchQuantityAccessibility(document);
  if (window.MutationObserver) {
    const quantityObserver = new MutationObserver(mutations => {
      mutations.forEach(mutation => mutation.addedNodes.forEach(node => {
        if (node.nodeType === 1) patchQuantityAccessibility(node);
      }));
    });
    quantityObserver.observe(document.body, {childList:true, subtree:true});
  }
})();

/* lf5-menu-alt-patch */
(function () {
  function patchMenuAlts(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('#shopify-section-header-inline img[alt=""]').forEach(function (image) {
      var link = image.closest('a');
      if (!link) return;
      var href = link.getAttribute('href') || '';
      if (href.indexOf('/collections/kitchen-appliances') !== -1) {
        image.alt = 'Kitchen appliances collection';
      } else if (href.indexOf('/products/translid_spicebox') !== -1) {
        image.alt = 'LA’ FORTE transparent-lid stainless steel spice box';
      }
    });
  }

  function initMenuAltPatch() {
    patchMenuAlts(document);
    var header = document.getElementById('shopify-section-header-inline');
    if (!header || !window.MutationObserver) return;
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) patchMenuAlts(node);
        });
      });
    });
    observer.observe(header, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMenuAltPatch, { once: true });
  } else {
    initMenuAltPatch();
  }
})();
